import Startup from '@/views/profile/StartupProfile'
import PublicStartup from '@/views/startups/PublicStartup.vue'
import Startups from "@/views/search/ManualSearch.vue";
import MyStartups from "@/views/startups/MyStartups";
import FindByDomain from "@/views/startups/FindByDomain";
import MyContacts from "@/views/startups/MyContacts.vue";

export default [
    {
        path: '/startups',
        component: Startups,
        meta: {
            title: 'Startups',
            access: ['enterprise'],
        }
    },
    {
        path: '/startups/my-startups',
        component: MyStartups,
        meta: {
            title: 'My Startups',
        }
    },
    {
        path: '/startups/find-by-domain',
        component: FindByDomain,
        meta: {
            access: ['enterprise','ecosystem'],
            guest: true,
        }
    },
    {
        path: '/startups/my-contacts',
        component: MyContacts,
        meta: {
            title: 'My Contacts',
        }
    },
    {
        path: '/startups/:id',
        component: Startup,
        meta: {
            access: ['enterprise','ecosystem']
        }
    },
    {
        path: '/public-startup/:domain',
        component: PublicStartup,
        meta: {
            guest: true,
            onlyGuest: true,
        }
    },
]
